import React from "react";
import {useConfig} from "../context/ConfigContext";



const HealthCheckRoute = () => {
       return <>OK</>;
};

export default HealthCheckRoute;